interface SectionHeadingProps {
  eyebrow: string;
  icon?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  icon = "ri-bookmark-3-line",
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`flex flex-col ${isCenter ? "items-center text-center" : "items-start"}`}>
      <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-100 border border-background-200 font-label text-xs text-foreground-700">
        <span className="w-4 h-4 flex items-center justify-center text-primary-600">
          <i className={`${icon} text-[13px]`}></i>
        </span>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-4 font-body text-sm md:text-base text-foreground-600 leading-relaxed ${
            isCenter ? "max-w-2xl" : "max-w-3xl"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}